var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.item.hidden
    ? _c(
        "div",
        [
          _vm.hasOneShowingChild(_vm.item.children, _vm.item) &&
          (!_vm.onlyOneChild.children || _vm.onlyOneChild.noShowingChildren) &&
          !_vm.item.alwaysShow
            ? _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onSidebarMenuAction(_vm.item)
                    },
                  },
                },
                [
                  _vm.onlyOneChild.meta
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-menu-item",
                            {
                              class: {
                                "submenu-title-noDropdown": !_vm.isNest,
                              },
                              attrs: { index: _vm.item.name },
                            },
                            [
                              _c("Item", {
                                attrs: {
                                  icon:
                                    _vm.onlyOneChild.meta.icon ||
                                    (_vm.item.meta && _vm.item.meta.icon),
                                  title: _vm.generateTitle(_vm.item.name),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            : [
                _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onSidebarMenuAction(_vm.item)
                      },
                    },
                  },
                  [
                    _c(
                      "el-menu-item",
                      {
                        class: { "submenu-title-noDropdown": !_vm.isNest },
                        attrs: { index: _vm.item.name },
                      },
                      [
                        _vm.item.meta
                          ? _c("Item", {
                              staticClass: "firstItem",
                              attrs: {
                                icon: _vm.item.meta && _vm.item.meta.icon,
                                title: _vm.generateTitle(_vm.item.name),
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }